import { Injectable } from "@angular/core";

import { Config } from "@core/models/config";
import { ResidenceService } from "./residence.service";

@Injectable({
	providedIn: 'root'
})
export class ConfigService {

	private config: Config;

	constructor(private residenceService: ResidenceService) {

		this.config = this.getConfigFromLocalStorage();
	}

	public async initializeConfig(): Promise<Config> {

		return new Promise<any>(async (resolve, reject) => {

			if (!this.config) {

				this.config = new Config();
				this.config.network = 'wifi';
			}

			this.residenceService.getResidenceResponse(0, 50)
				.then((response) => {
					if (!(this.config.residence && response.items.some(item => item.code == this.config.residence.code))) {

						this.config.residence = response.items[0];
						localStorage.setItem('config', JSON.stringify(this.config));
					}

					resolve(this.config);
				})
				.catch((error) => reject(error));

		});
	}

	private getConfigFromLocalStorage(): Config {

		return JSON.parse(localStorage.getItem('config'));
	}

	public getConfig(): Config {

		return this.config;
	}

	public saveConfig(config: Config) {

		this.config = config;
		localStorage.setItem('config', JSON.stringify(this.config));
	}
}